import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {Document, Equipment, KeyValueGroup, Partner, Location} from '@app/shared';
import {NZ_DRAWER_DATA, NzDrawerRef, NzDrawerService} from 'ng-zorro-antd/drawer';
import {ProjectUtilsService} from '../../services/project-utils.service';
import {DocDrawerComponent} from '../../../../shared/components/doc-drawer/doc-drawer.component';
import {DrawerEscapeBlockerService, ScreenService} from '@app/core';
import {combineLatest, take} from 'rxjs';
import {GlobalValuesService} from '../../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-equipment-detail-drawer',
  standalone: false,

  templateUrl: './equipment-detail-drawer.component.html',
  styleUrl: './equipment-detail-drawer.component.less',
})
export class EquipmentDetailDrawerComponent {
  nzData: { equipment: Equipment } = inject(NZ_DRAWER_DATA);

  equipmetUrl = (window.location as any).origin + '/maestro/equipment';

  docCardsActivate: number[] = [];
  partnerOpcions: Partner[] = [];

  docDrawer: any;
  constructor(
    private drawerRef: NzDrawerRef<string>,
    public ps: ProjectUtilsService,
    private drawerService: NzDrawerService,
    private screenService: ScreenService,
    public globalValuesService: GlobalValuesService,
    public authService: AuthService,
    private drawerEscapeBlocker: DrawerEscapeBlockerService,
  ) {
    this.globalValuesService.isPartnerReady$
      .pipe(takeUntilDestroyed())
      .subscribe((value) => {
        if (value) {
          this.partnerOpcions = globalValuesService.partnerlist;
        }
      });
  }

  ngOnInit(): void {
    this.drawerEscapeBlocker.block();
  }

  close(): void {
    this.drawerRef.close(this.nzData);
  }

  setKeyValueData(): KeyValueGroup[] {
    return [
      {
        name: 'data',
        layout: 'normal',
        items: [
          {
            parentObject: this.nzData.equipment,
            component: 'EquipmentDetailDrawerComponent',
            label: 'Propietario',
            type: 'avatar',
            path: 'ownerId',
            required: true,
            editable: false,
            list: this.partnerOpcions,
            value: {
              userId: this.nzData.equipment.ownerId,
            },
          },
          {
            parentObject: this.nzData.equipment,
            component: 'EquipmentDetailDrawerComponent',
            label: 'Contacto asociado',
            type: 'avatar',
            path: 'contactId',
            required: true,
            editable: false,
            list: this.partnerOpcions,
            value: {
              userId: this.nzData.equipment.contactId,
            },
          },
        ],
      },
    ];
  }

  onActionBtn(type: string, doc: Document) {
    if (type === 'drawer') {
      this.openDocDrawer(doc);
    }
  }

  toggleDocCardsActivate(value: number): void {
    if (this.docCardsActivate.includes(value)) {
      this.docCardsActivate = this.docCardsActivate.filter((v) => v !== value);
    } else {
      this.docCardsActivate.push(value);
    }
  }

  openDocDrawer(doc: Document): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        this.docDrawer = this.drawerService.create({
          nzWidth: 635,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMask: false,
          nzContent: DocDrawerComponent,
          nzData: {
            document: doc,
            showOptions: false,
          },
        });
      });
  }

  ngOnDestroy(): void {
    this.drawerEscapeBlocker.unblock();
  }
}
